import React, { Component } from "react";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import Util from "../util.js";
import './detailInformation.css'
class Performance extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  goBack = () => {
    hashHistory.goBack();
  };

  render() {
    const {renderDOM,background=false,title,style}=this.props
    return (
      <div className={`${background?"per_container":'no_ackground'}`} style={{backgroundColor:'transparent'}}>
        <div className="Performance_content" style={style}>
          <div className="Performance_title">{title}</div>
          <div className="table_info">
            {renderDOM}
          </div>  
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome: state.SupperFundHome,
  };
}
export default connect(mapStateToProps)(Performance);



// WEBPACK FOOTER //
// ./src/components/Performance.js